import moment from 'moment';

export const PACIFIC_TIME_ZONE = 'America/Los_Angeles';

const pacificDateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: PACIFIC_TIME_ZONE,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

export const getPacificDateParts = (date = new Date()) => {
  const parts = pacificDateFormatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== 'literal') {
      acc[part.type] = Number(part.value);
    }

    return acc;
  }, {});

  return {
    year: parts.year,
    month: parts.month,
    day: parts.day,
  };
};

export const getPacificRelativeDateParts = offsetDays => {
  const today = getPacificDateParts();
  const nextDate = moment([today.year, today.month - 1, today.day]).add(
    offsetDays,
    'days',
  );

  return {
    year: nextDate.year(),
    month: nextDate.month() + 1,
    day: nextDate.date(),
  };
};

export const getNextPacificWeekdayDateParts = offsetDays => {
  const today = getPacificDateParts();
  const nextDate = moment([today.year, today.month - 1, today.day]).add(
    offsetDays,
    'days',
  );

  while ([0, 6].includes(nextDate.day())) {
    nextDate.add(1, 'day');
  }

  return {
    year: nextDate.year(),
    month: nextDate.month() + 1,
    day: nextDate.date(),
  };
};

export const getFirstWeekdayDateParts = (year, month) => {
  const firstWeekday = moment([year, month - 1, 1]);

  while ([0, 6].includes(firstWeekday.day())) {
    firstWeekday.add(1, 'day');
  }

  return {
    year: firstWeekday.year(),
    month: firstWeekday.month() + 1,
    day: firstWeekday.date(),
  };
};

export const getPacificTodayMoment = () => {
  const today = getPacificDateParts();
  return moment([today.year, today.month - 1, today.day]);
};

export const formatPacificTimeRange = (startTime, endTime) => {
  if (!startTime) {
    return '';
  }

  return endTime ? `${startTime} to ${endTime} PT` : `${startTime} PT`;
};
